import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { pointSend } from "../../../../api/pub-point";
import { pubState } from "../../../../recoil/pub.atom";
import {
  ButtonGroup,
  ManualPointContentWrapper,
  ManualPointCumulativeWrapper,
  ManualPointHeader,
  ManualPointInputItem,
  ManualPointInputWrapper,
  ManualPointMemberWrapper,
  ManualPointWrapper,
} from "../../style/popup";
import SearchMember from "../search-member";
import { getPubMemberList, PubMemberDto } from "../../../../api/member";
import { WideState } from "../../../../recoil/wide";
import ManualPointHistory from "./components/history";
import { exchangePoint, exchangePointToWon } from "../../../../utils/number";

interface Props {
  onClose: () => void;
  transactionPoint: number;
  weeklyTransactionPoint: number;
}

const ManualPointPopup = ({
  onClose,
  transactionPoint,
  weeklyTransactionPoint,
}: Props) => {
  const pub = useRecoilValue(pubState);
  const [member, setMember] = useState<PubMemberDto | null>(null);
  const [point, setPoint] = useState<number>(0);
  const [givePoint, setGivePoint] = useState<number>(0);
  const [deletePoint, setDeletePoint] = useState<number>(0);
  const [resultPoint, setResultPoint] = useState<number>(0);
  const [requestPoint, setRequestPoint] = useState<number>(0);
  const [memo, setMemo] = useState("");
  const [isHistory, setIsHistory] = useState(false);
  const isWide = useRecoilValue(WideState);

  useEffect(() => {
    if (!member) return;
    setPoint(member.point);
  }, [member]);

  const handlerSave = async () => {
    if (!pub || !member) return;
    if (memo === "") {
      alert("메모를 입력해주세요.");
      return;
    }
    const point = {
      memberId: member.memberId,
      pointAmount: requestPoint,
      memo,
      pubId: pub.id,
      type: deletePoint !== 0 ? "WITHDRAW" : "TRANSFER",
    };

    try {
      const res = await pointSend(point);
      alert(res.message);

      onClose();
    } catch (e: any) {
      alert(e.message);
      console.log(e);
    }
  };

  useEffect(() => {
    let sum = point + givePoint - deletePoint;
    setResultPoint(sum);
    let req = givePoint - deletePoint;
    setRequestPoint(req);
  }, [givePoint, deletePoint]);

  const checkValue = (value: string) => {
    if (!pub) return +value;
    const rawValue = value.replace(/,/g, "");
    let newValue = +exchangePointToWon(+rawValue);
    if (newValue < 0) {
      newValue *= -1;
    }
    return newValue;
  };

  const getMemberData = async () => {
    if (!pub || !member) return;
    try {
      const res = await getPubMemberList(member.nickname, pub.id);
      if (res.memberList.length > 0) {
        setMember(res.memberList[0]);
      } else {
        setMember(null);
      }
    } catch {
      return;
    }
  };

  return (
    <ManualPointWrapper isWide={isWide}>
      {isHistory && member && (
        <ManualPointHistory
          member={member}
          onClose={() => {
            setIsHistory(false);
          }}
          getMemberData={getMemberData}
        />
      )}
      <ManualPointHeader>
        <div className="header">
          <div className="title">매장 이용권 수동 지급</div>
          <div className="sub">매장부담</div>
        </div>
        <div className="info">
          *지급되는 매장 이용권에 관한 책임은 본사에서 부담하지 않습니다.
        </div>
      </ManualPointHeader>
      {member && !isWide ? (
        <></>
      ) : (
        <SearchMember setSelectMember={setMember} selectMember={member} />
      )}
      <ManualPointContentWrapper>
        {member && (
          <ManualPointMemberWrapper isWide={isWide}>
            <div className="box">
              <div>{member.nickname}님 보유 매장 이용권</div>
              <div>
                {exchangePoint(point)}E
                <div className="history" onClick={() => setIsHistory(true)}>
                  내역 확인
                </div>
              </div>
            </div>

            <ManualPointInputWrapper isWide={isWide}>
              <ManualPointInputItem isWide={isWide}>
                지급
                {isWide ? (
                  <>
                    <br />
                    매장 이용권
                  </>
                ) : (
                  " E"
                )}
                <input
                  type="text"
                  inputMode="numeric"
                  value={exchangePoint(givePoint)}
                  onChange={(e) => {
                    const value = checkValue(e.target.value);
                    setGivePoint(value);
                  }}
                />
              </ManualPointInputItem>
              <ManualPointInputItem isWide={isWide}>
                차감
                {isWide ? (
                  <>
                    <br />
                    매장 이용권
                  </>
                ) : (
                  " E"
                )}
                <input
                  type="text"
                  inputMode="numeric"
                  value={exchangePoint(deletePoint)}
                  onChange={(e) => {
                    const value = checkValue(e.target.value);
                    setDeletePoint(value);
                  }}
                />
              </ManualPointInputItem>
            </ManualPointInputWrapper>
            <ManualPointInputItem isWide={isWide}>
              <div className="memo">메모</div>
              <input
                className="memo-input"
                type="text"
                value={memo}
                onChange={(e) => {
                  setMemo(e.target.value);
                }}
              />
            </ManualPointInputItem>
            <div className="result">
              <div>{`적용된 ${isWide ? "매장 이용권" : "E"}`}</div>
              <div>{exchangePoint(resultPoint) + "E"}</div>
            </div>
            <ManualPointCumulativeWrapper>
              <div className="item">
                금일 지급 누계
                <div>
                  {exchangePoint(transactionPoint)}E /{" "}
                  <span>{transactionPoint.toLocaleString()}</span>
                </div>
              </div>
              <div className="item">
                금주 지급 누계
                <div>
                  {exchangePoint(weeklyTransactionPoint)}E /{" "}
                  <span>{weeklyTransactionPoint.toLocaleString()}</span>
                </div>
              </div>
            </ManualPointCumulativeWrapper>
          </ManualPointMemberWrapper>
        )}
      </ManualPointContentWrapper>
      <ButtonGroup>
        <div className="button purple" onClick={() => handlerSave()}>
          저장
        </div>
        <div
          className="button"
          onClick={() => {
            onClose();
          }}
        >
          취소
        </div>
      </ButtonGroup>
    </ManualPointWrapper>
  );
};

export default ManualPointPopup;
